export default "__VITE_ASSET__be9a36c2__"